import { CalendarFilter, Identifiable } from "@planzone/dto";
import { Range } from "./types";

function sameUuids(
  a: Identifiable<unknown>[] | undefined,
  b: Identifiable<unknown>[] | undefined,
): boolean {
  const aIds = (a || []).map(({ uuid }) => uuid).sort();
  const bIds = (b || []).map(({ uuid }) => uuid).sort();
  return aIds.length === bIds.length && aIds.every((id, i) => id === bIds[i]);
}

function sameTags(
  a: { name: string }[] | undefined,
  b: { name: string }[] | undefined,
): boolean {
  const aNames = (a || []).map(({ name }) => name).sort();
  const bNames = (b || []).map(({ name }) => name).sort();
  return (
    aNames.length === bNames.length && aNames.every((n, i) => n === bNames[i])
  );
}

function sameStrings(
  a: string[] | undefined,
  b: string[] | undefined,
): boolean {
  const aSorted = (a || []).slice().sort();
  const bSorted = (b || []).slice().sort();
  return (
    aSorted.length === bSorted.length &&
    aSorted.every((s, i) => s === bSorted[i])
  );
}

function match(first: CalendarFilter, second: CalendarFilter) {
  return (
    first.startDate === second.startDate &&
    first.endDate === second.endDate &&
    sameUuids(first.projects, second.projects) &&
    sameUuids(first.resources, second.resources) &&
    sameUuids(first.projectPortfolios, second.projectPortfolios) &&
    sameUuids(first.projectStatuses, second.projectStatuses) &&
    sameTags(first.projectsTags, second.projectsTags) &&
    sameStrings(first.elementTypes, second.elementTypes)
  );
}

function roundDate(date: string) {
  const _date = new Date(date);

  return new Date(
    _date.getFullYear(),
    _date.getMonth(),
    _date.getDate(),
    0,
    0,
    0,
  );
}

function isInRange(first: Range, second: Range) {
  const fStart = roundDate(first.startDate);
  const sStart = roundDate(second.startDate);
  const fEnd = roundDate(first.endDate);
  const sEnd = roundDate(second.endDate);

  return (fStart <= sStart && sStart <= fEnd) || (sEnd <= fEnd && sEnd <= fEnd);
}

export { match, isInRange };
